import React, { useEffect, useState, useRef  } from "react";
import { useParams } from "react-router-dom";
import API from "../../../api/client";
import * as ENDPOINTS from "../../../api/endpoints";

const InvoicePdf = () => {
  const buttonRef = useRef(null);
  const [downloadUrl, setDownloadUrl] = useState();
  const params = useParams();
  const getInvoice = async () => {
    const url = `${ENDPOINTS.INVOICE_PDF}/${params.invoice_id}`;
    try {
      const response = await API.getFile(url, {
        responseType: "blob",
      });
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(pdfBlob);
      setDownloadUrl(blobUrl);
      buttonRef.current.click();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    getInvoice();
  }, []);

  const linkStyle = {
    display: "none"
  };

  return (
    <>
      {downloadUrl && (
        <a href={downloadUrl} ref={buttonRef} style={linkStyle}>Prind PDF</a>
      )}
    </>
  );
};

export default InvoicePdf;
